// extracted by mini-css-extract-plugin
module.exports = {"customerLogosContainer":"CustomerLogos_customerLogosContainer__Fhnw7","customerLogos":"CustomerLogos_customerLogos__X_xG5"};